module.exports = __webpack_public_path__ + "img/geofisica2_4-3_2048.ea2327a7.jpg";